<template>
    <div class="orderManagementClass">
        <div class="orderManagementContent" :style="contentViewHeight">
            <div class="printOrderListBox">
                <div>
                    <div class="orderSearchBox">
                        <el-input v-model="circleName" placeholder="名称"></el-input>
                        <el-button class="searchBtn" @click="search">搜索</el-button>
                        <el-button type="text" class="resetBtn" @click="resetData">
                            <i class="iconfont icon-qingchushujuku"></i>
                            <span>清除条件</span>
                        </el-button>
                    </div>
                    <div class="orderListTable">
                        <div class="tableTool">
                            <div class="toolRight">
                                <el-button type="primary" size="small"  @click="toDialog('add')"><i
                                    class="el-icon-circle-plus-outline"></i>新增
                                </el-button>
                                <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDelete"><i
                                    class="el-icon-delete"></i>删除
                                </el-button>
                            </div>
                        </div>
                        <el-table
                            :data="tableData"
                            border
                            @selection-change="handleSelectionChange"
                            style="width: 100%" class="tableContent">
                            <el-table-column
                                type="selection"
                                header-align="center"
                                align="center"
                                width="55">
                            </el-table-column>
                            <el-table-column
                                prop="fileUrl"
                                label="封面"
                                width="200"
                                header-align="center"
                                show-overflow-tooltip
                                align="center">
                                <template slot-scope="scope">
                                    <img v-if="scope.row.fileUrl !=null" :src="scope.row.fileUrl">
                                    <img v-else src="@/assets/images/defaultOrder.png">
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="circleName"
                                label="圈子名称"
                                header-align="center"
                                width="200"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="content"
                                align="center"
                                header-align="center"
                                label="圈子内容" >
                                <template slot-scope="scope">
                                     <el-popover
                                        placement="top-start"
                                        width="500"
                                        trigger="hover"
                                        :content="scope.row.content">
                                        <span slot="reference" class="circleContent">{{scope.row.content}}</span>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="addNum"
                                label="关注数量"
                                header-align="center"
                                width="80px"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="dynamicCount"
                                label="动态数量"
                                width="80px"
                                header-align="center"
                                align="center">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                align="center"
                                header-align="center"
                                width="160"
                                label="创建时间">
                            </el-table-column>
                            <el-table-column
                                label="操作"
                                header-align="center"
                                width="100"
                                align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="toDialog('edit',scope.row.uuid)">编辑</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            @prev-click="handleCurrentChange"
                            @next-click="handleCurrentChange"
                            layout="total,prev, pager, next,jumper"
                            :current-page="current"
                            :page-size="pageSize"
                            :total="total" class="pagination">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            :title="titleDialog"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="900px">
            <div class="dialogContent" v-loading="loading">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="圈子名称" prop="circleName">
                        <el-input v-model="form.circleName" placeholder="请输入圈子名称"  show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="圈子封面" prop="fileUrl">
                        <div style="display: flex;" v-loading="thumbnailLoading">
                            <el-upload
                                action="/service-center/upload/file/single"
                                :show-file-list="false"
                                :headers="headers"
                                :width="'100'"
                                :height="'100'"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload" class="thumbnailClass">
                                <div class="avatar" v-if="!form.fileUrl">
                                    <i class="el-icon-plus"></i>
                                </div>
                                <div>
                                    <el-image
                                        v-if="form.fileUrl"
                                        :src="form.fileUrl"
                                        class="thumbnailClass"
                                        style="border: solid 1px #ececec;background-color: #f9f9f9;"
                                        >
                                    </el-image>
                                </div>
                            </el-upload>
                        </div>
                        <span style="color:#DCDFE6" >请上传100 * 100px的图片，2M以内</span>
                    </el-form-item>
                    <el-form-item label="圈子介绍" prop="content">
                        <el-input type="textarea" v-model="form.content" style="width:600px" :rows="6"  show-word-limit></el-input>
                    </el-form-item>

                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        circleQuery,
        getCircle,
        deleteCircle,
        saveCircle
    } from '../../utils/interface';

    import uploadImage from '@/components/uploadImage'
    export default {
        components: {
            uploadImage,
        },
        data() {
            return {
                circleName:'',
                titleDialog:'',
                type: 'SYSTEM',
                tableData: [],
                current: 1,
                pageSize: 10,
                total: 0,
                multipleSelection:[],
                form:{uuid:'',circleName:'',fileUrl:'',content:'',type: 'SYSTEM',},
                rules:{
                    circleName: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 0, max: 30, message: '最多允许输入30个汉字', trigger: 'blur'}
                    ],
                    content: [
                        {required: true, message: '请输入内容',trigger: 'blur'},
                        {min: 0, max: 80, message: '最多允许输入80个汉字', trigger: 'blur'}
                    ],
                    fileUrl: [
                        {required: true, message: '请上传圈子封面'}
                    ],
                },
                loading:false,
                uuid:'',
                dialogVisible:false,
                headers: {
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("api_access_token")
                },
                thumbnailLoading:false,
            }
        },
        computed: {
            contentViewHeight() {
                let height = document.documentElement.clientHeight - 120
                return {minHeight: height + 'px'}
            },
        },
        created() {
            this.getList();
        },
        methods: {
            getList(){
                let params = {
                    type: this.type,
                    circleName:this.circleName,
                    current:this.current,
                    pageSize:this.pageSize,
                }
                circleQuery(params).then((res)=>{
                    this.tableData = res.data;
                    this.total = res.total;
                });
            },
            resetData(){
                this.circleName = '';
                this.current = 1;
                this.getList();
            },
            // 分页
            handleCurrentChange(val){
                this.current = val;
                this.getList();
            },
            search(){
                this.current = 1;
                this.getList();
            },
            init(){
                this.circleName = '';
                this.current = 1;
                this.getList()
            },
            handleDelete(){
                let uuidArr=[];
                this.multipleSelection.map((item) => {
                    uuidArr.push(item.uuid);
                });
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCircle(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            // 编辑/新增
            toDialog(type,id){
                this.dialogVisible = true
                this.uuid = id;
                if (type === 'add') {
                    this.titleDialog = '新增'
                    this.uuid = ''
                    this.reset()
                } else {
                    this.titleDialog = '编辑'
                    this.uuid = id
                    this.getDetail(id)
                }
            },
            getDetail(uuid){
                getCircle(uuid).then((item)=>{
                    this.form = item.data;
                })
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        this.loading = true
                        this.form.uuid=this.uuid;
                        saveCircle(this.form).then((res)=>{
                            this.$message.success('保存成功！')
                            this.loading = false
                            this.dialogVisible = false
                            this.getList();
                        })
                    } else {
                        return false;
                    }
                });
            },
            reset() {
                this.form = {
                    uuid:'',circleName:'',fileUrl:'',content:'',type: 'SYSTEM',
                }
                this.$nextTick(()=>{
                    if(this.$refs.ruleForm){
                        this.$refs.ruleForm.clearValidate()
                    }
                })
            },
            handleAvatarSuccess(res, file) {
                this.form.fileUrl = res.url;
                console.log(this.form)
                this.thumbnailLoading = false;
                this.$refs.ruleForm.validateField('fileUrl');
            },
            beforeAvatarUpload(file) {
                this.thumbnailLoading = true;
                const isJPG = file.type.indexOf('image') !== -1;
                if (!isJPG) {
                    this.thumbnailLoading = false
                    this.$message.warning('上传图片只能是图片格式!');
                    this.thumbnailLoading = false
                }
                return isJPG ;
            },
        }
    }
</script>

<style scoped lang="less">
.orderManagementClass {
    position: relative;
    width: 100%;
    padding: 0 20px 20px;
    .orderManagementContent {
        background: #fff;
        .printOrderListBox {
            padding: 20px;
            .orderSearchBox {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-input {
                    width: initial;
                    margin-bottom: 22px;
                    margin-right: 30px;
                }

                /deep/ .el-input__inner {
                    width: 242px;
                    height: 35px;
                    min-height: 35px;
                    font-size: 12px;
                    color: #999999;
                    background-color: #f2f4f7;
                    border: 1px solid #f2f4f7;
                    border-radius: 5px;

                    &:hover,
                    &:focus {
                        background-color: #fff;
                        border: 1px solid #108ee9;
                    }
                }

                /deep/ .el-input__prefix {
                    top: -3px;
                }

                /deep/ .el-input__suffix {
                    top: 2px;
                }

                /deep/ .el-button {
                    display: block;
                    line-height: 35px;
                    padding: 0;
                    height: 35px;
                }

                .searchBtn {
                    width: 82px;
                    background: #3d7fff;
                    border: none;
                    border-radius: 15px;
                    font-size: 14px;
                    color: #ffffff;
                }

                .resetBtn {
                    color: #333333;
                }
            }

            .tableContent {
                min-height: 650px;

                /deep/ .el-table__header {
                    tr {
                        th {
                            border-right: none;
                        }
                    }

                    /deep/ .el-table__cell {
                        padding: 5px 0;
                        background: #f2f5fc;
                    }
                }

                /deep/ .el-table__body {
                    img {
                        vertical-align: middle;
                        width: 52px;
                        height: 50px;
                    }
                }
            }

            .pagination {
                margin-top: 20px;
                text-align: right;
            }
        }
    }
    .tableTool {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        .toolRight {
            button {
                width: 83px;
                height: 30px;
                background: rgba(21, 126, 251, 1);
                border: none;
                border-radius: 15px;
                font-size: 13px;
                color: #fff;

                i {
                    padding-right: 5px;
                }

                &:hover {
                    background: #61a2f0;
                }
            }
        }
    }
    .dialogBox{
        .details{
            .detailsItem{
                padding-bottom: 20px;
                h3{
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    .one-row{
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                    .two-row{
                        width: 100%;
                        margin-bottom: 22px;
                        display: flex;
                        .label{
                            padding-right: 15px;
                            min-width: 95px;
                        }
                        .name{
                            color: #000;
                        }
                    }
                }
                .itemPictureContent{
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row{
                        width: 30%;
                        margin-bottom: 22px;
                        img{
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name{
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label{
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
        .audit{
            padding-bottom: 20px;
            h3{
                font-weight: 700;
                font-size: 16px;
                color: #000;
                margin-top: 0;
                letter-spacing: 1px;
                border-bottom: 1px solid #ddd;
                padding-bottom: 15px;
            }
            .auditContent{
                padding: 0 30px;
            }
            .cause{
                display: flex;
                margin-top: 20px;
                .causeTitle{
                    min-width: 80px;
                    color: #3a8ee6;
                }
                .causeContent{
                    color: #000;
                }
            }
            .auditEnter{
                text-align: center;
                padding-top: 20px;
                button{
                    width: 120px;
                }
            }
        }
    }
}
.circleContent {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.thumbnailClass{
    width: 200px;
    height: 200px;
    .avatar{
        width: 200px;
        height: 200px;
        border: 1px dashed #ddd;
        border-radius: 4px;
        line-height: 200px;
        font-size: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/circle/circleManager.vue